const options = {
  5: "bg-red-500/5",
  10: "bg-red-500/10",
  25: "bg-red-500/25",
  50: "bg-red-500/50",
  75: "bg-red-500/75",
  90: "bg-red-500/90",
  100: "bg-red-500",
};

const from = {
  5: "from-red-500/5",
  10: "from-red-500/10",
  25: "from-red-500/25",
  50: "from-red-500/50",
  75: "from-red-500/75",
  90: "from-red-500/90",
  100: "from-red-500",
};

export default function getBackgroundRed500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
